// extracted by mini-css-extract-plugin
module.exports = {"seriesScorecard":"style_seriesScorecard__bDzoP","title":"style_title__WCAmx"};